export const SUBMIT_HR_APPROVAL = "You are able to submit more days than you have remaining, but will require HR approval.";

export const UNABLE_SUBMIT_MORE_THAN_ALLOTMENT = "You are unable to submit more days than you have remaining";

export const NOT_ALLOTMENT_FOR_NEXT_YEAR = "Allotment for next year has not been set yet";

export const MORNING_OUT_KEY = "MorningOut";

export const AFTERNOON_OUT_KEY = "AfternoonOut";

export const FULL_DAY_KEY = "FullDay";

export const daysOptions = [
    {
        label: "Full Day",
        value: FULL_DAY_KEY
    },
    {
        label: "Morning Out",
        value: MORNING_OUT_KEY
    },
    {
        label: "Afternoon Out",
        value: AFTERNOON_OUT_KEY
    },
];
